import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reset-password-form" }
const _hoisted_2 = { class: "mb-6 md:absolute top-8 inset-x-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-10 text-xs" }, " Enter your email address to receive a verification code to reset your password. ", -1)
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = {
  key: 0,
  class: "mb-10 text-xs"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-10 text-xs"
}
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = {
  key: 0,
  class: "mb-10 text-xs"
}
const _hoisted_9 = {
  key: 1,
  class: "mb-10 text-xs"
}
const _hoisted_10 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_FormError = _resolveComponent("FormError")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _component_InputCodeField = _resolveComponent("InputCodeField")!
  const _component_AvailableMethodSelector = _resolveComponent("AvailableMethodSelector")!
  const _directive_autofocus = _resolveDirective("autofocus")!
  const _directive_keyboard_submit = _resolveDirective("keyboard-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentAlert === _ctx.AlertEnum.RegularUser_TheFirstAttempt)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" If " + _toDisplayString(_ctx.composeTransportRecipients) + " associated with a valid account, a verification code has been sent. Check both inbox and spam folders for the code. ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.currentAlert === _ctx.AlertEnum.NotMigratedUser_TheFirstAttempt)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 1,
            type: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" To improve security we require that you reset your password at this time. As a first step, to confirm your identity, please enter the verification code sent to " + _toDisplayString(_ctx.composeTransportRecipients), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.currentAlert === _ctx.AlertEnum.AnyUser_TheNextAttempt)
        ? (_openBlock(), _createBlock(_component_Alert, {
            type: "success",
            key: _ctx.resetPasswordAttempts
          }, {
            default: _withCtx(() => [
              _createTextVNode(" If " + _toDisplayString(_ctx.composeTransportRecipients) + " associated with a valid account, a verification code has been sent. Check both inbox and spam folders for the code. ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.currentAlert === _ctx.AlertEnum.NotMigratedUser_FromRaiseWithCode)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 3,
            type: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Please set a new password following the requirements below. ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_FormError, { error: _ctx.error }, null, 8, ["error"])
    ]),
    (_ctx.resetState.is('STATE_SEND_CODE'))
      ? _withDirectives((_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetPassword()), ["prevent"])),
          novalidate: ""
        }, [
          _hoisted_3,
          _withDirectives(_createVNode(_component_InputField, {
            class: "block mb-4",
            label: "Email",
            name: "email",
            type: "email",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            validation: _ctx.v$.email,
            autocomplete: "email"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_autofocus]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_snap_button, {
              "button-type": "button",
              shape: "circular",
              size: "lg",
              variant: "tertiary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reset(), _ctx.$emit('cancel'))),
              class: "inline-block mr-2",
              "data-testid": "forgot_password-cancel1"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel ")
              ]),
              _: 1
            }),
            _createVNode(_component_snap_button, {
              "button-type": "submit",
              shape: "circular",
              size: "lg",
              variant: "primary",
              disabled: _ctx.state$.is('SUBMITTING'),
              class: "inline-block",
              "data-testid": "forgot_password-send"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Send ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)), [
          [_directive_keyboard_submit]
        ])
      : _createCommentVNode("", true),
    (_ctx.resetState.is('STATE_ENTER_CODE'))
      ? _withDirectives((_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.justVerifyCode()), ["prevent"])),
          novalidate: ""
        }, [
          (!_ctx.notMigrated)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Enter the verification code we sent to your " + _toDisplayString(_ctx.composeTransportLabels) + " in order to set your new password. ", 1))
            : _createCommentVNode("", true),
          (_ctx.notMigrated)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " In order to set a new password, please enter the verification code we sent to your " + _toDisplayString(_ctx.composeTransportLabels) + ". ", 1))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_InputCodeField, {
            class: "mb-2",
            label: "Enter verification code.",
            modelValue: _ctx.verificationCode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.verificationCode) = $event)),
            validation: _ctx.v$.verificationCode,
            "help-text": "Enter your 6-digit verification code."
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_autofocus]
          ]),
          _createVNode(_component_AvailableMethodSelector, {
            class: "mb-2",
            available: _ctx.resetAvailableTransports,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendCodeAgain($event)))
          }, null, 8, ["available"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_snap_button, {
              "button-type": "button",
              shape: "circular",
              size: "lg",
              variant: "tertiary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancel())),
              class: "inline-block mr-2",
              "data-testid": "forgot_password-cancel2"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel ")
              ]),
              _: 1
            }),
            _createVNode(_component_snap_button, {
              "button-type": "submit",
              shape: "circular",
              size: "lg",
              variant: "primary",
              disabled: _ctx.verificationCode.length < 6,
              class: "inline-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Continue ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)), [
          [_directive_keyboard_submit]
        ])
      : _createCommentVNode("", true),
    (_ctx.resetState.is('STATE_ENTER_PASSWORD'))
      ? _withDirectives((_openBlock(), _createElementBlock("form", {
          key: 2,
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.confirmNewPassword()), ["prevent"])),
          novalidate: ""
        }, [
          (!_ctx.resetPasswordEmail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Enter a new password below. "))
            : _createCommentVNode("", true),
          (_ctx.resetPasswordEmail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Enter a new password for " + _toDisplayString(_ctx.resetPasswordEmail) + " below. ", 1))
            : _createCommentVNode("", true),
          _createVNode(_component_InputField, {
            class: "block mb-4",
            autocomplete: "off",
            label: "New Password",
            name: "newPassword",
            type: "password",
            modelValue: _ctx.newPassword,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newPassword) = $event)),
            "help-text": "Your password must be 8-32 characters, and include at least one lowercase letter, one uppercase letter, and a number.",
            validation: _ctx.v$.newPassword
          }, null, 8, ["modelValue", "validation"]),
          _createVNode(_component_InputField, {
            class: "block mb-4",
            autocomplete: "off",
            label: "Confirm Password",
            name: "confirmPassword",
            type: "password",
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmPassword) = $event)),
            validation: _ctx.v$.confirmPassword
          }, null, 8, ["modelValue", "validation"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_snap_button, {
              "button-type": "button",
              size: "lg",
              variant: "tertiary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancel())),
              class: "inline-block mr-2",
              "data-testid": "forgot_password-cancel3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel ")
              ]),
              _: 1
            }),
            _createVNode(_component_snap_button, {
              "button-type": "submit",
              size: "lg",
              variant: "primary",
              disabled: _ctx.state$.is('SUBMITTING'),
              class: "inline-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Confirm ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)), [
          [_directive_keyboard_submit]
        ])
      : _createCommentVNode("", true)
  ]))
}